export default __webpack_public_path__ + "static/media/songs.299076aa.png";